import vuetifyMoney from "./VuetifyMoney.vue";

function install(Vue) {
  Vue.component("vuetify-money", vuetifyMoney);
}

export default install;
